import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import MultiStrategySignals from './pages/MultiStrategySignals';
import FundamentalSignals from './pages/FundamentalSignals';
import SwingStrategies from './pages/SwingStrategies';

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/multi-strategy-signals" element={<MultiStrategySignals />} />
      <Route path="/fundamental-signals" element={<FundamentalSignals />} />
      <Route path="/swing" element={<SwingStrategies />} />
    </Routes>
  );
}

export default App;
